import { ChildUser, FamilyChildProfile } from "@joonapp/web-shared"
import dayjs from "dayjs"

import TestimonialCarousel from "./TestimonialCarousel"
import childImageFemale6 from "../../images/testimonials/child-social-proof-female-6.png"
import childImageFemale8 from "../../images/testimonials/child-social-proof-female-8.png"
import childImageFemale9 from "../../images/testimonials/child-social-proof-female-9.png"
import childImageMale11 from "../../images/testimonials/child-social-proof-male-11.png"
import childImageMale4 from "../../images/testimonials/child-social-proof-male-4.png"
import childImageMale6 from "../../images/testimonials/child-social-proof-male-6.png"
import childImageMale9 from "../../images/testimonials/child-social-proof-male-9.png"
import { useFamilyQuery } from "../../networking/queries"
import { FamilyQuerySelect } from "../../types"

export function ChildTestimonialCarousel() {
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const testimonials = getChildTestimonials(children)

  return <TestimonialCarousel testimonials={testimonials} />
}

const childQuotes = {
  loveJoon: `"I looove Joon! ITS MY FAVORITE GAME!!"`,
  funFunFun: `"Joon is fun, fun, fun, FUN!!"`,
  neverGetOld: `"My therapist said "well what happens when it gets old" my response was "Joon will NEVER get old for me!""`,
  inMyPov: `"I started using Joon abt a couple months ago and boy, I am waking up with my alarm, getting ready in the morning, and in general behaving better, well in my pov"`,
  betterThanRoblox: `"I loooove Joon! IT'S BETTER THAN ROBLOX!!"`,
}

const getOldestChildAge = (children: ChildUser[]) => {
  const childAges = children
    .filter((child) => !!child?.birthdate)
    .map((child) => dayjs().diff(dayjs(child?.birthdate), "year"))
  if (childAges.length === 0) return null
  return Math.max(...childAges)
}

const getChildTestimonials = (children: FamilyChildProfile[] | undefined) => {
  if (!children) return []
  const oldestChildAge = getOldestChildAge(children.map((child) => child.user))

  if (!oldestChildAge) {
    return [
      {
        image: childImageMale9,
        text: childQuotes.inMyPov,
        quotee: "Sam, 9, ADHD",
      },
      {
        image: childImageMale11,
        text: childQuotes.neverGetOld,
        quotee: "Johnny, 11, ADHD",
      },
      {
        image: childImageFemale6,
        text: childQuotes.funFunFun,
        quotee: "Jess, 6",
      },
      {
        image: childImageFemale9,
        text: childQuotes.betterThanRoblox,
        quotee: "Jess, 9",
      },
    ]
  } else if (oldestChildAge <= 5) {
    return [
      {
        image: childImageMale6,
        text: childQuotes.loveJoon,
        quotee: "Robert, 6, ADHD",
      },
      {
        image: childImageMale4,
        text: childQuotes.funFunFun,
        quotee: "Johnny, 5, ASD",
      },
      {
        image: childImageFemale9,
        text: childQuotes.neverGetOld,
        quotee: "Jess, 9",
      },
    ]
  } else if (oldestChildAge <= 7) {
    return [
      {
        image: childImageMale6,
        text: childQuotes.funFunFun,
        quotee: "Robert, 6, ADHD",
      },
      {
        image: childImageMale11,
        text: childQuotes.inMyPov,
        quotee: "Johnny, 11, ADHD",
      },
      {
        image: childImageFemale9,
        text: childQuotes.neverGetOld,
        quotee: "Jess, 9",
      },
    ]
  } else if (oldestChildAge <= 9) {
    return [
      {
        image: childImageMale9,
        text: childQuotes.inMyPov,
        quotee: "Johnny, 9, ADHD",
      },
      {
        image: childImageMale11,
        text: childQuotes.neverGetOld,
        quotee: "Timmy, 11, ADHD",
      },
      {
        image: childImageFemale8,
        text: childQuotes.funFunFun,
        quotee: "Jess, 7",
      },
    ]
  } else
    return [
      {
        image: childImageMale11,
        text: childQuotes.inMyPov,
        quotee: "Timmy, 11, AHDHD",
      },
      {
        image: childImageMale9,
        text: childQuotes.neverGetOld,
        quotee: "Johnny, 9, ADHD",
      },
      {
        image: childImageFemale8,
        text: childQuotes.funFunFun,
        quotee: "Jess, 7",
      },
    ]
}
